export default __webpack_public_path__ + "static/media/failed.be2c1f57.svg";